import React, { Component } from 'react'


export default class SmrFooter extends Component {
    render() {
        return (
            <div className="smr-footer">
                Версия: { this.props.smrVersion }
            </div>
        )
    }
}